import { ref } from 'vue';
import { useAdminStore } from '../stores/admin';
import { storeToRefs } from 'pinia';

export const useInstitutionSelect = () => {
  const store = useAdminStore();
  const { institutions } = storeToRefs(store);

  const selectedInstitutionCode = ref<string | null>(null);

  const fetchInstitutions = async () => {
    await store.fetch();
  };

  return {
    institutions,
    selectedInstitutionCode,
    fetchInstitutions,
  };
};
